import { NgModule } from '@angular/core';

import { LegacyDateValidator } from './legacy-date.validator';
import { MatchValidator }    from './match.validator';
import { NumberValidator }   from './number.validator';
import { PhoneValidator }    from './phone.validator';
import { PostcodeValidator } from './postcode.validator';
import { TimeValidator }     from './time.validator';

@NgModule({
  declarations: [
    LegacyDateValidator,
    MatchValidator,
    NumberValidator,
    PhoneValidator,
    PostcodeValidator,
    TimeValidator
  ],
  exports: [
    LegacyDateValidator,
    MatchValidator,
    NumberValidator,
    PhoneValidator,
    PostcodeValidator,
    TimeValidator
  ]
})
export class ValidatorsModule {}
